// The table contains published assessments only. Personal drafts live in the editor.
export default {
    computed: {
        assessmentContextKey() {
            const user = this.$store.getters.currentUser || {};
            return this.sheet && this.assessmentLine
                ? [user.company, user.userId || user.user_id || user.id, this.sheet.timesheet.id, this.assessmentLine.id, this.assessmentLine.employee_id].join(':') : '';
        }
    },
    methods: {
        mergeSharedCharacteristic(line) {
            if (this.lineDetailDrafts[line.id])
                this.$set(this.lineDetailDrafts[line.id], 'characteristic_values', {...line.characteristic_values});
        },
        assessmentDraftKey(line) {
            const user = this.$store.getters.currentUser || {};
            const id = user.userId || user.user_id || user.id;
            return id && user.company && this.sheet
                ? ['argus:assessment', user.company, id, this.sheet.timesheet.id, line.id].join(':') : null;
        }
    }
};
